var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-avatar',{attrs:{"tile":"","size":"220"}},[_c('v-img',{attrs:{"src":require('@/assets/list.svg')}})],1),_c('h2',{staticClass:"mt-3"},[_vm._v(" La liste est vide !! ")]),_c('p',{staticClass:"my-3 font-weight-medium fs-16"},[_vm._v(" Aucun enregistrement correspondant trouvé. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }